import axios from 'axios';

// search vat input api
export async function searchStatusAPI(Data) {
	let statuslist = [];
	const statusVal = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/status/search/?statusName=${statusVal}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		statuslist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return statuslist;
}

// check existing vat input api
export async function getStatusAPI(Data) {
	let statuslist = [];
	const StatusName = Data === undefined ? '' : Data;

	try{
		const response = await axios({
			method: 'GET',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/status/getStatus/?vatName=${StatusName}`,
			data: Data,
			headers: { 
				'content-type': 'application/json',
			}
		});
		  
		const { data } = response;
		statuslist = data;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return statuslist;
}

//create status api
export async function createStatusAPI(Data, userID) {
	let statusData = [];
	try{
		const axiosResponse = await axios({
			method: 'POST',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/status/create/`,
			data: {Data, userID}
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		statusData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return statusData;
}

//update status api
export async function updateStatusAPI(Data, vatID, userID) {
	let statusData = [];
	try{
		const axiosResponse = await axios({
			method: 'PUT',
			url: `${process.env.REACT_APP_BACKEND_API}lookup/status/update/?statusID=${vatID}&userID=${userID}`,
			data: Data
		}).then(response => {
			return response;
		});
  
		// @ts-ignore
		statusData = axiosResponse;
	} 
	catch(error) {
		throw error;
		// Message.error();
	}
	
	return statusData;
}